// Copyright (c) Move Closer 2022.

import { QueryParams } from '@movecloser/front-core'

import { RegistryResponse } from '@core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const ContentRepositoryType = Symbol.for('IContentRepository')

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface IContentRepository {
  load (slug: string, query?: QueryParams, translateCode?: boolean): Promise<RegistryResponse>
}
